export default "__VITE_ASSET__DZQzBDEy__"